import Vue from 'vue';
import styled, { css } from 'vue-styled-components';
import DateRangePicker from 'vue2-daterange-picker';

export const StartDateText = styled('div', { color: String })`
    flex: 1;
    ${({ color }) =>
        css`
            color: ${color};
        `}
`;

export const ConnectionDatePicker = styled(
    Vue.component('connection-date-picker', DateRangePicker)
)`
    .form-control {
        height: 40px;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 7px 10px;
        border: 1px solid #bdc2c7;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 400;
        color: #6e767d;
    }

    .daterangepicker {
        .month {
            font-size: 13px;
            font-weight: 600;
            color: #3c464f;
        }

        th {
            font-size: 13px;
            font-weight: 500;
            color: #6e767d;
        }

        td {
            font-size: 13px;
            font-weight: 500;
            color: #4a4a4a;

            &:hover {
                background-color: #f7f7f7;
                color: #6e767d;
            }

            &.active {
                background-color: #0042eb;
                color: #ffffff;
            }

            &.disabled {
                background-color: unset !important;
                cursor: not-allowed !important;
                color: #bdc2c7;
            }
        }
    }
`;
